import { DonoTrainConfigCard } from "@/cards/DonoTrainConfigCard";
import { DonoTrainInfo } from "@/cards/DonoTrainInfo";
import { DonoTrainWidget } from "@/Components/DonoTrainWidget/DonoTrainWidget";
import { useSocket } from "@/hooks/useSocket";
import { useSocketCallback } from "@/hooks/useSocketCallback";
import { useSocketEvent } from "@/hooks/useSocketEvent";
import { DonoTrain, DonoTrainSettings } from "@ailenax-overlay/shared";
import { FC, useCallback, useEffect, useState } from "react";

const state: DonoTrain["status"]|false = false;

export const DonoTrainPage: FC = () => {
    const [train, setTrain] = useState<DonoTrain | null>(null);
    const [offset, setOffset] = useState<number>(0);
    const [settings, setSettings] = useState<DonoTrainSettings | null>(null);
    const socket = useSocket();

    useSocketEvent("dono-train", (e) => {
        if (state !== false) return;
        setTrain(e.train);
        setOffset(Date.now() - e.timeReference.getTime());
    });

    useSocketEvent("dono-train-settings-update", (e) => {
        setSettings(e.settings);
    });

    useSocketCallback("get-dono-train", (train, timeReference) => {
        if (state !== false) return;
        setTrain(train);
        setOffset(Date.now() - timeReference.getTime());
    });

    useSocketCallback("get-donotrain-settings", setSettings);

    useEffect(() => {
        if (state === false) return;

        switch (state) {
            case "ready":
                setTrain({
                    status: "ready",
                });
                break;
            case "primed":
                setTrain({
                    id: "123",
                    status: "primed",
                    expiresAt: new Date(Date.now() + 1000 * 60 * 5),
                    primedAt: new Date(),
                });
                break;
            case "in-progress":
                setTrain({
                    id: "123",
                    status: "in-progress",
                    level: 10,
                    total: 5000,
                    progress: 52.3,
                    required: 100,
                    startedAt: new Date(),
                    expiresAt: new Date(Date.now() + 1000 * 60 * 5),
                    record: {
                      level: 11,
                      percent: 80
                    }
                });
                break;
            case "cooldown":
                setTrain({
                    status: "cooldown",
                    level: 10,
                    total: 5000,
                    progress: 50,
                    cooldownReadyAt: new Date(Date.now() + 1000 * 60 * 5),
                    required: 100,
                    entries: []
                });
                break;
        }
    }, [socket]);

    const save = useCallback((settings: DonoTrainSettings) => {
        settings.goals.sort((a, b) => a.level - b.level);
        socket.emit("update-donotrain-settings", settings);
        setSettings(settings);
    }, [socket]);
    
    return train && (
        <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12">
                <div className="w-[460px] m-auto">
                    <DonoTrainWidget boxMode={settings?.boxMode} inConfigMode={true} train={train} offset={offset} goals={settings?.goals} leaderboardTextLeft={settings?.leaderboardTextLeft} leaderboardTextRight={settings?.leaderboardTextRight}/>
                </div>
            </div>
            { settings && (
                <DonoTrainConfigCard train={train} settings={settings} saveSettings={save} />
            )}
            <DonoTrainInfo/>
        </div>
    );
}